"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatEventsHelper = void 0;
const events_1 = require("@front/event/events");
const component_1 = require("../component");
class ChatEventsHelper {
    static setEvents() {
        this.on('selectionChanged', (event) => {
            this.kdbPick.bind(this)(event);
        });
        this.on('fullscanChanged', (event) => {
            this.fullscan = event.detail.value;
        });
        this.on(events_1.appEvents.frontChatConversationStart, (event) => {
            const { conversationId } = event.detail;
            if (conversationId) {
                this.getConvo(conversationId);
            }
        });
        this.on(events_1.appEvents.frontChatConversationEnd, (event) => {
            // Update the signal to clear conversation
            this.conversationSignal.setValue(null);
            const chatComponent = this.$('app-chat');
            if (chatComponent) {
                chatComponent.setConversationData(null);
                chatComponent.clearChat();
            }
        });
        this.on(events_1.appEvents.injectMessages, async (event) => {
            const { conversation, messages } = event.detail;
            this.injectedMessages = messages;
            console.log({ messages });
            // Update conversation through signal
            this.conversationSignal.setValue({ conversation: conversation, frontMessages: messages, isNew: false });
            // Get the chat component and set conversation data
            const chatComponent = this.$('app-chat');
            if (chatComponent && chatComponent.setConversationData) {
                chatComponent.setConversationData(conversation, messages);
            }
            // Only set the model if no model is currently selected
            if (!this.selectedModel && !this.selectedAvatarId) {
                if (conversation.model) {
                    const selectedModel = {
                        model: conversation.model.model,
                        provider: conversation.model.provider,
                        aiProvider: conversation.model.aiProvider,
                        avatar: conversation.model.avatar
                    };
                    // Update the signal instead of local state
                    this.modelSignal.setValue(selectedModel);
                }
            }
        });
        this.on(events_1.appEvents.frontChatWebSearch, (event) => {
            this.webSearchEnabled = event.detail;
            this.storageService.set('ai.webSearchEnabled', this.webSearchEnabled ? 'true' : 'false');
        });
        this.on(events_1.appEvents.frontChatDeepSearch, (event) => {
            this.deepSearchEnabled = event.detail;
            this.storageService.set('ai.deepSearchEnabled', this.deepSearchEnabled ? 'true' : 'false');
        });
        // Listen for model sync events from chat component
        this.on('modelSynced', async (event) => {
            const { model, aiProvider, avatar } = event.detail;
            // Create a selected model object and update the signal
            const selectedModel = {
                model: model.model,
                provider: model.provider,
                aiProvider: aiProvider,
                avatar: avatar
            };
            // Update the signal instead of local state
            this.modelSignal.setValue(selectedModel);
        });
        this.on('chat:clean:model', (event) => {
            // Clear the model signal
            this.modelSignal.setValue(null);
        });
        window.addEventListener('resize', () => {
            this.chatHeight = window.innerHeight - component_1.ChatPage.layoutPaddings;
        });
    }
}
exports.ChatEventsHelper = ChatEventsHelper;
